import { render, staticRenderFns } from "./TeamContainer.vue?vue&type=template&id=9a969ed8&scoped=true&"
import script from "./TeamContainer.vue?vue&type=script&lang=js&"
export * from "./TeamContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a969ed8",
  null
  
)

export default component.exports